<div class="m-16">
  <h2 mat-dialog-title class="text-center">{{ data.title }}</h2>
  <mat-dialog-content>
    @if (data.type) {
      @if (data.type === 'success') {
        <app-checkmark></app-checkmark>
      }
      @if (data.type === 'error') {
        <app-error-mark></app-error-mark>
      }
    }
    <p class="text-center" [innerText]="data.message"></p>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <su-button label="OK" [mat-dialog-close]="true"></su-button>
  </mat-dialog-actions>
</div>
